import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, AlertCircle, ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Legacy Shopify URL redirect page.
 *
 * The DJ's old Shopify store had product URLs like
 *   https://www.kehelekeffmusic.com/products/vipmashuppackvol92025
 * Social-media posts still link to those paths. When someone lands here we ask the
 * backend which current album owns that slug and redirect them to /release/{id}.
 * If no album has that slug yet, we show a helpful "release moved" message.
 */
const LegacyRedirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('loading');

  useEffect(() => {
    if (!slug) {
      setState('not_found');
      return;
    }
    (async () => {
      try {
        const { data } = await axios.get(`${API}/legacy-redirect/${encodeURIComponent(slug)}`);
        if (data?.album_id) {
          navigate(`/release/${data.album_id}`, { replace: true });
        } else {
          setState('not_found');
        }
      } catch {
        setState('not_found');
      }
    })();
  }, [slug, navigate]);

  if (state === 'loading') {
    return (
      <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
        <div className="text-center">
          <Loader2 className="mx-auto mb-4 text-[#00F0FF] animate-spin" size={40} />
          <p className="text-[#A1A1AA] text-sm">Finding your release…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-[#121214] border border-[#27272A] rounded-lg p-8 text-center">
        <AlertCircle className="mx-auto mb-4 text-yellow-400" size={48} />
        <h1 className="text-xl font-semibold mb-2">This release has moved</h1>
        <p className="text-sm text-[#A1A1AA] mb-6">
          We couldn't find a release matching that old link. Browse the current catalog to find what you're looking for.
        </p>
        <Link
          to="/collections"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#00F0FF] hover:bg-[#33F3FF] text-black font-medium text-sm"
        >
          Browse releases
        </Link>
        <button onClick={() => navigate('/')} className="mt-4 text-xs text-[#71717A] hover:text-[#A1A1AA] inline-flex items-center gap-1 mx-auto block">
          <ArrowLeft size={12} /> Back to store
        </button>
      </div>
    </div>
  );
};

export default LegacyRedirect;
